/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1MatchMode } from '../models/V1MatchMode';
import { V1MatchScope } from '../models/V1MatchScope';
import { HttpFile } from '../http/http';

/**
* a single filter applied on audience generation for auxiliary files.
*/
export class V1AuxiliaryFileFilter {
    /**
    * The ID of the target to use as an auxiliary file.
    */
    'targetId'?: string;
    'matchMode'?: V1MatchMode;
    'matchScope'?: V1MatchScope;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "targetId",
            "baseName": "target_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "matchMode",
            "baseName": "match_mode",
            "type": "V1MatchMode",
            "format": ""
        },
        {
            "name": "matchScope",
            "baseName": "match_scope",
            "type": "V1MatchScope",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1AuxiliaryFileFilter.attributeTypeMap;
    }

    public constructor() {
    }
}

